import React from "react";
import "./CompInfo.css";

import CountDownTimer from "./CountDownTimer";
import { DateTime } from "luxon";

const CompInfo = ({ activeCompetition, reloadNewComp, remainingGuesses, guesses }) => {
    const [word, setWord] = React.useState("");

    const shouldRenderWord = () => {
        setWordToRender();

        if (guesses && guesses.length > 0 && guesses[guesses.length - 1].result.word) return true;
        if (activeCompetition && activeCompetition.user && activeCompetition.user.currentGuesses.length > 0 && activeCompetition.user.currentGuesses[activeCompetition.user.currentGuesses.length - 1].word) return true;

        return false;
    }

    const setWordToRender = () => {
        if (guesses && guesses.length > 0 && guesses[guesses.length - 1].result.word) {
            if (word === guesses[guesses.length - 1].result.word) return;


            setTimeout(() => {
                setWord(guesses[guesses.length - 1].result.word)
            }, 5000);
            return;
        }

        if (activeCompetition && activeCompetition.user && activeCompetition.user.currentGuesses.length > 0 && activeCompetition.user.currentGuesses[activeCompetition.user.currentGuesses.length - 1].word) {
            if (word === activeCompetition.user.currentGuesses[activeCompetition.user.currentGuesses.length - 1].word) return;

            setWord(activeCompetition.user.currentGuesses[activeCompetition.user.currentGuesses.length - 1].word);
            return;
        }

        if (word)
            setWord();
        return false;
    }

    return (
        <div className="game-info-container">
            <div className="game-info-header">
                <div className="game-info-left">
                    <h2 className="title">
                        {activeCompetition.compInfo.title}
                    </h2>
                    <div className="competition-details">
                        <div className="detail-card">
                            <div className="detail-label">
                                <span className="info-icon">👤</span>
                                Owner
                            </div>
                            <div className="detail-value">
                                {activeCompetition.compInfo.createdBy}
                                {activeCompetition.compInfo.isUserOwner && (
                                    <span className="owner-badge">You</span>
                                )}
                            </div>
                        </div>
                        
                        <div className="detail-card">
                            <div className="detail-label">
                                <span className="info-icon">🎯</span>
                                Attempts Left
                            </div>
                            <div className={`detail-value ${
                                remainingGuesses <= 1 ? 'attempts-danger' : 
                                remainingGuesses <= 3 ? 'attempts-warning' : 
                                'attempts-remaining'
                            }`}>
                                {remainingGuesses}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="game-info-right">
                    <div className={`game-status-container ${getCompetitionStatusClass(activeCompetition)}`}>
                        <div className="status-circle"></div>
                        <span className="game-status-text">
                            {getCompetitionStatusText(activeCompetition)}
                        </span>
                    </div>
                    
                    {activeCompetition.compInfo.started && (
                        <p className="date-info">
                            <span className="info-icon">📅</span>
                            {activeCompetition.compInfo.finished ? "Finished on" : "Ends"}: {' '}
                            {DateTime.fromJSDate(new Date(activeCompetition.compInfo.endDate))
                                .toLocaleString(DateTime.DATE_FULL)}
                        </p>
                    )}

                    {!activeCompetition.compInfo.started && (
                        <div className="countdown-container">
                            <CountDownTimer 
                                startDate={activeCompetition.compInfo.startDate} 
                                reloadNewComp={reloadNewComp}
                            />
                        </div>
                    )}
                </div>
            </div>

            {shouldRenderWord() && (
                <div className="correct-word-container">
                    <div className="correct-word-label">Correct Word</div>
                    <div className="correct-word">{word}</div>
                </div>
            )}
        </div>
    )
}

const getCompetitionStatusClass = (competition) => {
    if (competition.compInfo.finished) return "status-finished";
    if (!competition.compInfo.started) return "status-starting";
    return "status-running";
}

const getCompetitionStatusColour = (competition) => {
    if (competition.compInfo.finished) return "red";

    if (!competition.compInfo.started) return "yellow";

    return "green";
}

const getCompetitionStatusText = (competition) => {
    if (competition.compInfo.finished) return "Finished";

    if (!competition.compInfo.started) return "Starting soon";

    return "Running";
}



export default CompInfo;